<template>
    <div class="upload-request-info">
        <table class="table">
            <tr>
                <th>ID</th>
                <td>{{ uploadRequest.id }}</td>
            </tr>
            <tr>
                <th>Started at</th>
                <td>{{ uploadRequest.started_at }}</td>
            </tr>
            <tr>
                <th>Job id</th>
                <td>{{ uploadRequest.job_id }}</td>
            </tr>
            <tr>
                <th>Finished at</th>
                <td>{{ uploadRequest.finished_at }}</td>
            </tr>
            <tr>
                <th>Result</th>
                <td>
                    <XmlUploadRequestResult :request="uploadRequest"/>
                </td>
            </tr>
            <tr>
                <th>Targets</th>
                <td>
                    <b-button
                        class="target-button"
                        v-for="[product, target] of Object.entries(this.productsTargetsDict)"
                        :key="product"
                        tag="router-link"
                        type="is-link is-light"
                        :to="generateTargetLink(product, target)"
                    >
                        {{ target }}
                    </b-button>
                </td>
            </tr>
            <tr>
                <th>Message</th>
                <div class="upload-request-message-container" v-if="uploadRequest.message">
                    <b-button class="copy-message-button"
                      icon-left="content-copy"
                      @click="copyMessage"
                      rounded
                      size="is-small"
                      type="is-dark"/>
                    <pre class="upload-request-message">{{ uploadRequest.message }}</pre>
                </div>
            </tr>
        </table>

        <vue-json-pretty
            :data="requestJSON">

            <template #nodeValue="{ node, defaultValue }">
                <template v-if="typeof node.content === 'string' && node.content.startsWith('https://')">
                    <a :href="node.content" target="_blank">{{ node.content }}</a>
                </template>
                <template v-else>{{ defaultValue }}</template>
            </template>
        </vue-json-pretty>
    </div>
</template>

<script>
    import VueJsonPretty from "vue-json-pretty";
    import XmlUploadRequestResult from "@/components/XmlUploadRequestResult.vue";

    export default {
        name: "UploadRequestInfo",
        props: {
            uploadRequest: Object,
        },
        computed: {
            requestJSON() {
                return JSON.parse(this.uploadRequest.params)
            },
            productsTargetsDict() {
                let products_targets = this.requestJSON.products_targets
                if (!products_targets) {
                    products_targets = {}
                    products_targets[this.requestJSON.product] = this.requestJSON.name
                }
                else {
                    products_targets = JSON.parse(this.requestJSON.products_targets)
                }

                return products_targets
            },
        },
        methods: {
            copyMessage() {
                this.$copyText(this.uploadRequest.message)
                    .then(() => this.$buefy.toast.open('Message was copied'));
            },
            generateTargetLink(productName, targetName) {
                let platformName = this.requestJSON.platform_name
                let platformVersion = this.requestJSON.platform_version
                let platformArchitecture = this.requestJSON.platform_architecture
                let platform = this.requestJSON.platform

                const query = {
                    branches: this.requestJSON.branch,
                    target_name: targetName,
                    products: productName,
                    mtrs: this.requestJSON.mtr,
                }
                if (platformName && platformVersion && platformArchitecture) {
                    query['platform_name'] = platformName
                    query['platform_version'] = platformVersion
                    query['platform_architecture'] = platformArchitecture
                }
                else {
                    query['platform_name'] = platform
                }
                return { name: 'TestRunIndex', query };
            },
        },
        components: {
            XmlUploadRequestResult,
            VueJsonPretty,
        }
    }
</script>

<style lang="scss">
    .upload-request-message-container {
        position: relative;
    }

    .copy-message-button {
        position: absolute;
        top: 1em;
        right: 1em;
    }

    .upload-request-content__subtitle {
        display: flex;
        align-items: center;
    }

    .target-button {
        margin-right: 10px;
    }

    .table tr th {
        text-align: center;
        vertical-align: middle;
    }
</style>